<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="generic-modal-container create-rca-dialog"
  (onHide)="close()"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h2>{{ rcaDataToPatch ? 'Edit Regulatory Change Assessment' : 'Create a New Regulatory Change Assessment' }}</h2>
    </div>
  </ng-template>

  <div class="modal-body">
    <form [formGroup]="rcaForm" autocomplete="off">
      <div class="form-grid-container" [class.has-other-design-docs]="showOtherDesignDocsField">
        <!-- Column 1 & 2 Fields (Left Side - 6 Rows) -->
        <!-- Row 1 -->
        <div class="form-group">
          <label for="title">Title <span class="required">*</span></label>
          <input
            id="title"
            type="text"
            pInputText
            placeholder="Enter Title"
            formControlName="title"
          />
        </div>
        
        <div class="form-group">
          <label for="region">Region <span class="required">*</span></label>
          <p-multiSelect
            id="region"
            [options]="regions"
            optionLabel="name"
            [filter]="true"
            formControlName="region"
            placeholder="Select Region(s)"
            [appendTo]="'body'"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['region'].invalid }"
            display="chip"
            [maxSelectedLabels]="3"
            selectedItemsLabel="{0} regions selected"
          ></p-multiSelect>
        </div>
        <div class="form-group">
          <label for="usClassification">US Classification <span class="required">*</span></label>
          <p-dropdown
            id="usClassification"
            [options]="usClassifications"
            optionLabel="name"
            [filter]="true"
            formControlName="usClassification"
            placeholder="Select US Classification"
            [appendTo]="'body'"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['usClassification'].invalid }"
          ></p-dropdown>
        </div>

        <!-- Row 2 -->
        <div class="form-group">
          <label for="country">Country <span class="required">*</span></label>
          <p-multiSelect
            id="country"
            [options]="countries"
            optionLabel="name"
            [filter]="true"
            formControlName="country"
            placeholder="Select Countries"
            [appendTo]="'body'"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['country'].invalid }"
            display="chip"
            [maxSelectedLabels]="3"
            selectedItemsLabel="{0} countries selected"
          ></p-multiSelect>
        </div>
        <div class="form-group">
          <label for="usMedDeviceClass">
            US Med Device Class
            <!-- Conditional asterisk based on usClassification value -->
            <span class="required" *ngIf="rcaForm.get('usClassification')?.value?.name === 'Yes'">*</span>
          </label>
          <p-dropdown
            id="usMedDeviceClass"
            [options]="usMedDeviceOptions"
            optionLabel="name"
            [filter]="true"
            formControlName="usMedDeviceClass"
            placeholder="Select US Med Device Class"
            [appendTo]="'body'"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['usMedDeviceClass'].invalid }"
          ></p-dropdown>
        </div>

        <!-- Row 3 -->
       
        <div class="form-group">
          <label for="ecrnEcnNumber">ECRN/ECN Number (optional)</label>
          <input
            id="ecrnEcnNumber"
            type="text"
            pInputText
            placeholder="Enter ECRN/ECN Number"
            formControlName="ecrnEcnNumber"
          />
        </div>
        <div class="form-group">
          <label for="euClassification">EU Classification <span class="required">*</span></label>
          <p-dropdown
            id="euClassification"
            [options]="euClassifications"
            optionLabel="name"
            [filter]="true"
            formControlName="euClassification"
            placeholder="Select EU Classification"
            [appendTo]="'body'"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['euClassification'].invalid }"
          ></p-dropdown>
        </div>

        <!-- Row 4 -->
        <div class="form-group">
          <label for="typeOfChange">Type of Change <span class="required">*</span></label>
          <p-multiSelect
            id="typeOfChange"
            [options]="typeOfChanges"
            optionLabel="name"
            [filter]="true"
            formControlName="typeOfChange"
            placeholder="Select Types of Change"
            [appendTo]="'body'"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['typeOfChange'].invalid }"
            display="chip"
            [maxSelectedLabels]="3"
            selectedItemsLabel="{0} types selected"
          ></p-multiSelect>
        </div>
        <div class="form-group">
          <label for="euMedDeviceClass">
            EU Med Device Class
            <!-- Conditional asterisk based on euClassification value -->
            <span class="required" *ngIf="rcaForm.get('euClassification')?.value?.name === 'Yes'">*</span>
          </label>
          <p-dropdown
            id="euMedDeviceClass"
            [options]="euMedDeviceOptions"
            optionLabel="name"
            [filter]="true"
            formControlName="euMedDeviceClass"
            placeholder="Select EU Med Device Class"
            [appendTo]="'body'"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['euMedDeviceClass'].invalid }"
          ></p-dropdown>
        </div>

        <!-- Row 5 -->
        <div class="form-group">
          <label for="productFamily">Product Family <span class="required">*</span></label>
          <p-multiSelect
            id="productFamily"
            [options]="productFamilies"
            optionLabel="name"
            [filter]="true"
            formControlName="productFamily"
            placeholder="Select Product Families"
            [appendTo]="'body'"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['productFamily'].invalid }"
            display="chip"
            [maxSelectedLabels]="3"
            selectedItemsLabel="{0} families selected"
          ></p-multiSelect>
        </div>
        <div class="form-group">
          <label for="issuedDate">Issued Date <span class="required">*</span></label>
          <p-calendar
            id="issuedDate"
            formControlName="issuedDate"
            [showIcon]="true"
            dateFormat="yy-mm-dd"
            placeholder="Select Issued Date"
            [appendTo]="'body'"
            [readonlyInput]="true"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['issuedDate'].invalid }"
          ></p-calendar>
        </div>

        <!-- Row 6 -->
        <div class="form-group">
          <label for="catalogueNumber">Catalogue Number <span class="required">*</span></label>
          <input
            id="catalogueNumber"
            type="text"
            pInputText
            placeholder="Enter Catalogue Number"
            formControlName="catalogueNumber"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['catalogueNumber'].invalid }"
          />
        </div>
        <div class="form-group">
          <label for="dueDate">Due Date <span class="required">*</span></label>
          <p-calendar
            id="dueDate"
            formControlName="dueDate"
            [showIcon]="true"
            dateFormat="yy-mm-dd"
            placeholder="Select Due Date"
            [appendTo]="'body'"
            [minDate]="dueDateMinDate"
            [readonlyInput]="true"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['dueDate'].invalid }"
          ></p-calendar>
        </div>

        <!-- Column 3 Fields (Right Side - Spanning) -->
        <div class="form-group product-design-history-group">
          <label for="productDesignHistoryDocumentation">Product Design History Documentation <span class="required">*</span></label>
          <p-multiSelect
            id="productDesignHistoryDocumentation"
            [options]="productDesignHistoryOptions"
            optionLabel="name"
            [filter]="true"
            formControlName="productDesignHistoryDocumentation"
            placeholder="Select Product Design History Documentation"
            [appendTo]="'body'"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['productDesignHistoryDocumentation'].invalid }"
            display="chip"
            [maxSelectedLabels]="3"
            selectedItemsLabel="{0} documents selected"
          ></p-multiSelect>
        </div>

        <!-- Other Design Docs field - shown when "Other(s)" is selected -->
        <div class="form-group other-design-docs-group" *ngIf="showOtherDesignDocsField">
          <label for="otherDesignDocs">Other Design Docs <span class="required">*</span></label>
          <input
            id="otherDesignDocs"
            type="text"
            pInputText
            placeholder="Enter custom validation documentation and internal test reports"
            formControlName="otherDesignDocs"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['otherDesignDocs'].invalid }"
          />
        </div>

        <div class="form-group change-description-group">
          <label for="changeDescription">Change Description <span class="required">*</span></label>
          <div
            class="change-description-editor-shell"
            *ngIf="!changeDescriptionMaxPreview"
            [class.change-description-editor-shell--invalid]="
              formSubmitted && rcaForm.controls['changeDescription'].invalid
            "
          >
            <div class="change-description-editor-chrome-header">
              <button
                type="button"
                pButton
                icon="pi pi-window-maximize"
                class="p-button-text p-button-rounded p-button-sm change-description-editor-chrome-btn"
                pTooltip="Open maximized editor"
                tooltipPosition="left"
                (click)="openChangeDescriptionMaxPreview()"
                aria-label="Open change description in maximized editor"
              ></button>
            </div>
            <p-editor
              id="changeDescription"
              formControlName="changeDescription"
              [style]="{'height':'257px'}"
              placeholder="Enter the description for change assessment"
              [modules]="editorModules"
              [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['changeDescription'].invalid }"
            ></p-editor>
          </div>
        </div>

        <!-- Column 4 Fields (Right Side - Spanning) -->
        <div class="form-group planned-timeframe-group">
          <label for="plannedTimeframeForImplementation">Planned Timeframe for Implementation <span class="required">*</span></label>
          <input
            id="plannedTimeframeForImplementation"
            type="text"
            pInputText
            placeholder="Enter Planned Timeframe for Implementation"
            formControlName="plannedTimeframeForImplementation"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['plannedTimeframeForImplementation'].invalid }"
          />
        </div>

        <div class="form-group additional-attachments-group">
          <label for="additionalAttachments">Additional Attachments (optional)</label>
          <div class="attachment-upload-container">
            <textarea
              id="additionalAttachments"
              pInputTextarea
              rows="2"
              placeholder="Description about the files uploaded"
              formControlName="additionalAttachmentsDescription"
              class="attachment-description"
            ></textarea>
            <!-- Hidden file input -->
            <input #fileInput type="file" multiple class="hidden-file-input" (change)="onFileSelect($event)"
              accept=".pdf,.doc,.docx,.xlsx,.pptx,.png,.jpg,.jpeg" />
            <div class="upload-area">
              <button pButton type="button" label="Add File" icon="pi pi-upload" class="p-button-warning upload-button"
                (click)="openFileSelector()" [disabled]="uploading"
                pTooltip="Supported: PDF, DOC, DOCX, XLSX, PPTX, PNG, JPG, JPEG. Max size 5 MB each"
                tooltipPosition="top"></button>
              <small *ngIf="uploadError" class="p-error">{{ uploadError }}</small>
            </div>
            <div class="attachments-list" *ngIf="uploadedFiles.length">
              <div class="attachment-item" *ngFor="let f of uploadedFiles; let i = index">
                <i class="pi pi-file mr-2"></i>
                <span class="file-name" [pTooltip]="f.name" tooltipPosition="top">{{ f.name }}</span>
                <span class="file-status" *ngIf="f.uploading"><i class="pi pi-spin pi-spinner"></i> Uploading...</span>
                <span class="file-status success" *ngIf="f.uploaded && !f.uploading"><i class="pi pi-check-circle"></i> Uploaded</span>
                <span class="file-status error" *ngIf="f.error"><i class="pi pi-exclamation-triangle"></i> {{ f.error }}</span>
                <button pButton type="button" icon="pi pi-download" class="p-button-text p-button-sm"
                  (click)="downloadUploadedOrLocal(f)" [disabled]="f.uploading || (!f.uploaded && !f.localBlobUrl)"
                  pTooltip="Download"></button>
                <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-danger p-button-sm"
                  (click)="removeFile(f)" [disabled]="f.uploading" pTooltip="Remove"></button>
              </div>
            </div>
            <div *ngIf="!uploadedFiles.length" class="no-files-placeholder">
              <small>No files uploaded yet.</small>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button pButton type="button" label="Export" class="p-button-secondary" (click)="onExport()"></button>
  <button pButton type="button" label="Save as Draft" class="p-button-secondary" (click)="onSaveAsDraft()" [disabled]="uploading || hasUploadingFiles()"></button>
      <button
        pButton
        type="button"
        label="Submit"
        class="p-button-warning"
        (click)="onSubmit()"
  [disabled]="uploading || hasUploadingFiles() || !rcaForm.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="changeDescriptionMaxPreview"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="false"
  [showHeader]="false"
  [closable]="false"
  position="top"
  styleClass="change-description-max-dialog change-description-max-dialog--editor"
  [contentStyle]="changeDescriptionMaxDialogContentStyle"
>
  <!-- Same chrome header as inline editor; dialog sits outside <form> — bind FormGroup for formControlName -->
  <div *ngIf="changeDescriptionMaxPreview" [formGroup]="rcaForm" class="change-description-max-editor-host">
    <div
      class="change-description-editor-shell change-description-editor-shell--max-dialog"
      [class.change-description-editor-shell--invalid]="
        formSubmitted && rcaForm.controls['changeDescription'].invalid
      "
    >
      <div class="change-description-editor-chrome-header change-description-editor-chrome-header--dialog">
        <span class="change-description-editor-chrome-title">Change Description</span>
        <button
          type="button"
          pButton
          icon="pi pi-window-minimize"
          class="p-button-text p-button-rounded p-button-sm change-description-editor-chrome-btn"
          pTooltip="Exit maximized editor"
          tooltipPosition="left"
          (click)="closeChangeDescriptionMaxPreview()"
          aria-label="Exit maximized change description editor"
        ></button>
      </div>
      <p-editor
        id="changeDescriptionMaximized"
        formControlName="changeDescription"
        [style]="changeDescriptionMaxEditorStyle"
        placeholder="Enter the description for change assessment"
        [modules]="editorModules"
        [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['changeDescription'].invalid }"
      ></p-editor>
    </div>
  </div>
</p-dialog>